import React from 'react';
import {
  View, Text, FlatList, TouchableOpacity,
  StyleSheet, Alert,
} from 'react-native';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import type { MapStackParamList } from '../../navigation/AppNavigator';
import { useLandmarksStore } from '../../store';
import { landmarksApi } from '../../api';
import type { Landmark } from '../../types';

type Props = NativeStackScreenProps<MapStackParamList, 'Landmarks'>;

export default function LandmarksScreen({ navigation }: Props) {
  const { landmarks, removeLandmark } = useLandmarksStore();

  function handleDelete(item: Landmark) {
    Alert.alert('Delete', `Delete "${item.name}"?`, [
      { text: 'Cancel', style: 'cancel' },
      {
        text: 'Delete', style: 'destructive', onPress: async () => {
          await landmarksApi.delete(item.landmarkId);
          removeLandmark(item.landmarkId);
        },
      },
    ]);
  }

  return (
    <View style={styles.container}>
      <FlatList
        data={landmarks}
        keyExtractor={(i) => i.landmarkId}
        ListEmptyComponent={<Text style={styles.empty}>No landmarks yet. Tap "+ Add Here" on the map!</Text>}
        renderItem={({ item }) => (
          <TouchableOpacity
            style={styles.row}
            onPress={() => navigation.navigate('LandmarkDetail', { landmarkId: item.landmarkId })}
          >
            <View style={styles.info}>
              <Text style={styles.name}>{item.name}</Text>
              <Text style={styles.meta}>
                {item.isPublic ? '🌐 Public' : '🔒 Private'} · {item.lat.toFixed(4)}, {item.lng.toFixed(4)}
              </Text>
            </View>
            <TouchableOpacity onPress={() => handleDelete(item)} style={styles.deleteBtn}>
              <Text style={styles.deleteText}>✕</Text>
            </TouchableOpacity>
          </TouchableOpacity>
        )}
        ItemSeparatorComponent={() => <View style={styles.sep} />}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#fff' },
  row: { flexDirection: 'row', alignItems: 'center', padding: 16 },
  info: { flex: 1 },
  name: { fontSize: 16, fontWeight: '600' },
  meta: { fontSize: 12, color: '#888', marginTop: 2 },
  deleteBtn: { padding: 8 },
  deleteText: { color: '#ea4335', fontSize: 16, fontWeight: '700' },
  sep: { height: 1, backgroundColor: '#f0f0f0' },
  empty: { textAlign: 'center', color: '#999', marginTop: 60, paddingHorizontal: 32 },
});
